module.exports = __webpack_public_path__ + "1d927799342ced5ae9c25764fb184960.svg";